var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { utilEvent } from "../../../utils/utilEvent";
import { TypeActionEventInfo } from "./actionEventInfo";
export var State;
(function (State) {
    State[State["PENDING"] = 0] = "PENDING";
    State[State["STARTED"] = 1] = "STARTED";
    State[State["ENDED"] = 2] = "ENDED";
})(State || (State = {}));
var initial = {
    coopLeagueEvent: [],
    customerEvent: [],
    farmEvent: [],
    leagueEvent: [],
    primeTimeEvent: [],
    themedEvent: [],
};
export var reducerEventInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionEventInfo.Received:
            return __assign({}, state, normalizeEvents(action.eventInfo));
        case TypeActionEventInfo.RemoveEvent:
            return __assign({}, removeEventById(state, action.eventId));
        case TypeActionEventInfo.StartEvent:
            return __assign({}, startEventById(state, action.eventId));
    }
    return state;
};
var removeEventById = function (eventInfo, id) {
    return iterateOnEvents(eventInfo, utilEvent.removeEventByIdModifier(id));
};
var normalizeEvents = function (eventInfo) {
    return iterateOnEvents(eventInfo, utilEvent.timestampModifier);
};
var startEventById = function (eventInfo, id) {
    return iterateOnEvents(eventInfo, utilEvent.startEventByIdModifier(id));
};
var iterateOnEvents = function (eventInfo, modifier) {
    return Object.keys(eventInfo).reduce(function (acc, key) {
        var _a;
        var arr = eventInfo[key] || [];
        if (arr.length > 0) {
            var modified = modifier(arr);
            Object.assign(acc, (_a = {},
                _a[key] = modified,
                _a));
        }
        return acc;
    }, {});
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/event/reducerEventInfo.ts
// module id = 558
// module chunks = 3